import { create, filter, findAll, findOne, getOne, resetSave, update } from "@/store/Crud/functions/actions";
import axios from "@/utils/axios";
export const livePayMandateActivate = async (store, options) => {
    store.commit("IS_LOADING", true);
    const request = axios
        .post(`live-pay-mandate/from-third-party/${options.token}`, options.data)
        .then((response) => {
        store.commit("SET_MANDATE_ID", response.data);
        store.commit("IS_LOADING", false);
    })
        .catch((error) => {
        store.commit("SET_ERROR", error);
        store.commit("IS_LOADING", false);
    });
    return request;
};
export const setAmountInEur = (store, amountInEur) => {
    store.commit("SET_AMOUNT_IN_EUR", amountInEur);
};
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
    livePayMandateActivate,
    setAmountInEur,
};
